<template lang="html">
	<div class="featured_events">
		<div v-if="!loaded" class="grid">
			<div class="grid_1-3">
				<div class="loader_wrap">
					<span class="loader loader--large"></span>
				</div>
			</div>

			<div class="grid_1-3">
				<div class="loader_wrap">
					<span class="loader loader--large"></span>
				</div>
			</div>

			<div class="grid_1-3">
				<div class="loader_wrap">
					<span class="loader loader--large"></span>
				</div>
			</div>
		</div>
		<transition name="fade">
			<div v-if="loaded">
				<div class="grid">
					<div class="grid_1-3" v-for="post in posts" :key="post.identifier">
						<div
							class="featured_event background"
							:style="{ backgroundImage: 'url(' + post.images.lg.url + ')' }"
						>
							<a :href="eventUrl(post)" class="full_link"></a>
							<div class="featured_event__bottom">
								<h4 class="featured_event__title">
									{{ post.name }}
								</h4>
								<p class="featured_event__date">
									{{ moment(post.datetime_start).format('dddd Do MMMM') }}
								</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</transition>
	</div>
</template>

<script>
import Vue from 'vue';
import moment from 'moment';

Vue.prototype.moment = moment;

export default {
	name: 'featured-events',
	data() {
		return {
			posts: [{ identifier: 1 }, { identifier: 2 }, { identifier: 3 }],
			loaded: false
		};
	},
	created: function() {
		// Alias the component instance as `vm`, so that we
		// can access it inside the promise function
		var vm = this;
		// Fetch our array of posts from an API
		fetch('https://nlfchurch.churchsuite.co.uk/embed/calendar/json?featured=1')
			.then(function(response) {
				return response.json();
			})
			.then(function(data) {
				vm.posts = data.slice(0, 3);
				vm.loaded = true;
			});
	},
	methods: {
		eventUrl(post) {
			const title = encodeURIComponent(post.name)
				.replace(/[!'()*]/g, '')
				.toLowerCase();
			const startDate = moment(post.datetime_start).format('YYYY-MM-DD');
			const endDate = moment(post.datetime_end).format('YYYY-MM-DD');
			const identifier = post.identifier;
			const url =
				'/nlfchurch/event/?title=' +
				title +
				'&date_start=' +
				startDate +
				'&date_end=' +
				endDate +
				'&identifier=' +
				identifier +
				'';
			return url;
		}
	}
};
</script>

<style lang="scss" scoped>
.featured_events {
	position: relative;
}

.grid_1-3 {
	max-width: 400px;
	width: 100%;
	min-height: 288px;
	margin: 0 0 40px;
	position: relative;
}

.featured_event {
	@include aspectRatio(80%);
	display: flex;
	justify-content: center;
	align-items: flex-end;
	text-align: center;
	box-shadow: 0px 10px 30px 0px rgba(0, 0, 0, 0.4);
	position: relative;

	&:before {
		height: 230px;
		@include pseudo(block, absolute, '');
		right: 0;
		bottom: 0;
		left: 0;
		/* Permalink - use to edit and share this gradient: https://colorzilla.com/gradient-editor/#000000+0,000000+100&0+0,0.7+74 */
		background: -moz-linear-gradient(
			top,
			rgba(0, 0, 0, 0) 0%,
			rgba(0, 0, 0, 0.7) 74%,
			rgba(0, 0, 0, 0.7) 100%
		); /* FF3.6-15 */
		background: -webkit-linear-gradient(
			top,
			rgba(0, 0, 0, 0) 0%,
			rgba(0, 0, 0, 0.7) 74%,
			rgba(0, 0, 0, 0.7) 100%
		); /* Chrome10-25,Safari5.1-6 */
		background: linear-gradient(
			to bottom,
			rgba(0, 0, 0, 0) 0%,
			rgba(0, 0, 0, 0.7) 74%,
			rgba(0, 0, 0, 0.7) 100%
		); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
		filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#00000000', endColorstr='#b3000000',GradientType=0 ); /* IE6-9 */

		z-index: 0;
	}

	&:hover {
		.featured_event__bottom {
			transform: translateY(-5px);
		}
	}
}

.featured_event__bottom {
	padding: 0 20px 22px;
	transition: 0.4s;
}

.featured_event__title {
	color: #ffffff;
	font-size: 24px;
	font-weight: $semiBold;
	margin: 0 0 10px;
	line-height: 1.2;
	position: relative;
}

.featured_event__date {
	color: #ffffff;
	opacity: 0.6;
	font-size: 16px;
	position: relative;
	margin: 0;
}

.loader_wrap {
	position: absolute;
	top: 50%;
	right: 0;
	left: 0;
	transform: translateY(-50%);
}

.loader--large {
	width: 60px;
	height: 60px;
	border: 5px solid #ffffff;
	border-right-color: transparent;
	border-top-color: transparent;
	margin: 0 auto;
}

@media screen and (max-width: 500px) {
	.grid_1-3 {
		min-height: 200px;
	}
}
</style>
